'use client';

import { Card, Grid } from '@repo/ui';
import { usePaymentStore } from '@/store/mutable-data/payment/PaymentStoreContext';
import PricingCard from '../PricingCard';

const PaymentMultiplePackages = (): JSX.Element => {
    const payment = usePaymentStore();
    return (
        <Grid container margin="3rem 0 0 0">
            {payment.paymentCart.slice(1).map((pckg) => {
                const packageItem = pckg.items[0]?.item;

                return (
                    <Grid item flex={1} key={packageItem?.id}>
                        <Card style={{ height: '100%' }}>
                            <PricingCard
                                price={packageItem?.price}
                                discount={packageItem?.discount}
                                discountedPrice={packageItem?.discountedPrice}
                                planId={packageItem?.id}
                                qty={1}
                                key={packageItem?.id}
                                image={packageItem?.image}
                                beforeTitle={`${packageItem?.credits} Articles ✨`}
                                topTitle={packageItem?.promoText}
                                description={packageItem?.description}
                            />
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default PaymentMultiplePackages;
